"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeKeyboardInput = void 0;
function makeKeyboardInput() {
    return new KeyboardInputImp();
}
exports.makeKeyboardInput = makeKeyboardInput;
class KeyboardInputImp {
    constructor() {
        this.controllers = [];
        this._eventElement = undefined;
        this.setEventElement = (element) => {
            this.clearInputElement();
            element.addEventListener("keydown", this.submitKeyDown, false);
            element.addEventListener("keyup", this.submitKeyUp, false);
            this._eventElement = element;
        };
        this.clearInputElement = () => {
            if (!this._eventElement)
                return;
            this._eventElement.removeEventListener("keydown", this.submitKeyDown);
            this._eventElement.removeEventListener("keyup", this.submitKeyUp);
            this._eventElement = undefined;
        };
        this.submitKeyDown = (e) => {
            this.controllers.forEach((c) => {
                if (c.onKeyDown) {
                    c.onKeyDown(e);
                }
            });
        };
        this.submitKeyUp = (e) => {
            this.controllers.forEach((c) => {
                if (c.onKeyUp) {
                    c.onKeyUp(e);
                }
            });
        };
        this.registerController = (controller) => {
            this.controllers.push(controller);
        };
        this.removeController = (controller) => {
            const index = this.controllers.indexOf(controller);
            if (index >= 0) {
                this.controllers.splice(index, 1);
            }
        };
    }
    get eventElement() {
        return this._eventElement;
    }
}
